export const accountConstants = {
  ACCOUNT_LOAD: '[Account] Load',
  ACCOUNT_LOAD_SUCCESS: '[Account] Load success',
  ACCOUNT_LOAD_FAILURE: '[Account] Load failure',
  ACCOUNT_RESET: '[Account] Reset',
  ACCOUNT_SAVE: '[Account] Save',
  ACCOUNT_SAVE_SUCCESS: '[Account] Save success',
  ACCOUNT_SAVE_FAILURE: '[Account] Save failure',
  ACCOUNT_DELETE: '[Account] Delete',
  ACCOUNT_DELETE_SUCCESS: '[Account] Delete success',
  ACCOUNT_DELETE_FAILURE: '[Account] Delete failure'
}
